/** Report detail page, holding tabs for analysis, kinematics, and overview */
import { IonIcon, IonLabel, IonLoading, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';

import * as React from 'react';

import { Redirect, Route } from 'react-router-dom';

import { useEffect, useState } from 'react';

// Custom Icons
import ORYX_VariabilityIcon from '../../../../assets/icons/ORYX_VariabilityIcon.svg';
import ORYX_ScissorsIcon from '../../../../assets/icons/ORYX_ScissorsIcon.svg';
import ORYX_AttractorsIcon from '../../../../assets/icons/ORYX_AttractorsIcon.svg';
import ORYX_ReportStatusIcon from '../../../../assets/icons/ORYX_ReportStatusIcon.svg';
import ORYX_KinematicsIcon from '../../../../assets/icons/ORYX_KinematicsIcon.svg';
import ORYX_InformationIcon from '../../../../assets/icons/ORYX_InformationIcon.svg';
import ORYX_JointCouplingIcon from '../../../../assets/icons/ORYX_JointCouplingIcon.svg';
import ORYX_MobilityIcon from '../../../../assets/icons/ORYX_MobilityIcon.svg';

//   Custom css
import './index.css';

import {
  WalkAnalysisReportTab,
  WalkKinematicsReportTab,
  WalkVariabilityReportTab,
  WalkJointCouplingReportTab,
  WalkMobilityReportTab,
} from '../../WalkReportV2';

interface ReportTab {
  url: string;
  title: string;
  status: string;
  icon: string;
}

const walkTabs: ReportTab[] = [
  {
    title: 'Mobility status',
    url: `mobilitystatus`,
    status: 'active',
    icon: ORYX_MobilityIcon,
  },
  {
    title: 'Analysis',
    url: `analysis`,
    status: 'active',
    icon: ORYX_ReportStatusIcon,
  },
  {
    title: 'Kinematics',
    url: 'kinematics',
    status: 'active',
    icon: ORYX_KinematicsIcon,
  },
  {
    title: 'Variability',
    url: 'variability',
    status: 'active',
    icon: ORYX_VariabilityIcon,
  },
  {
    title: 'Joint coupling',
    url: 'jointcoupling',
    status: 'active',
    icon: ORYX_JointCouplingIcon,
  },
  {
    title: 'Overview',
    url: 'overview',
    status: 'active',
    icon: ORYX_InformationIcon,
  },
];

interface RunTabsProps {
  id: string;
  data: any;
}

export const WalkTabBar = ({ id, data }: RunTabsProps) => {
  const [activeRunTab, setActiveRunTab] = useState('Mobility status');
  // console.log('data', data);
  const [loadingData, setLoadingData] = useState(false);

  // Set custom actions on the tabs
  const handleTabWillChange = (e: any) => {
    setActiveRunTab(e.detail.tab);
  };

  return (
    <IonTabs onIonTabsWillChange={handleTabWillChange}>
      {loadingData && (
        <IonLoading cssClass='my-custom-class' isOpen={loadingData} message={'Drawing graphs, one moment please...'} />
      )}
      <IonRouterOutlet id='main'>
        <Route
          path='/reportsV2/:id/mobilitystatus'
          render={(props) => {
            return <WalkMobilityReportTab {...props} report={data} />;
          }}
          exact={true}
        />
        <Route
          path='/reportsV2/:id/analysis'
          render={(props) => {
            return <WalkAnalysisReportTab {...props} report={data} />;
          }}
          exact={true}
        />
        <Route
          path='/reportsV2/:id/variability'
          render={(props) => {
            return <WalkVariabilityReportTab {...props} report={data} />;
          }}
          exact={true}
        />
        <Route
          path='/reportsV2/:id/kinematics'
          render={(props) => {
            return <WalkKinematicsReportTab {...props} report={data} setLoadingData={setLoadingData} />;
          }}
          exact={true}
        />
        <Route
          path='/reportsV2/:id/jointcoupling'
          render={(props) => {
            return <WalkJointCouplingReportTab {...props} report={data} />;
          }}
          exact={true}
        />

        <Route
          path={`/reportsV2/${id}`}
          render={() => <Redirect to={`/reportsV2/${id}/mobilitystatus`} />}
          exact={true}
        />
      </IonRouterOutlet>

      <IonTabBar slot='bottom' mode='ios'>
        {walkTabs.map((tab, _) => {
          let tabClassNames = '';
          if (tab.status === 'disabled') {
            tabClassNames = 'disabled';
          } else if (location.pathname === tab.url) {
            tabClassNames = 'ion-tab-button_selected';
          }
          return (
            <IonTabButton
              mode='ios'
              tab={tab.title}
              href={`/reportsV2/${id}/${tab.url}`}
              className={activeRunTab === tab.title ? 'ion-tab-button_selected' : ''}
              key={tab.title}>
              <IonIcon icon={tab.icon} />
              <IonLabel>{tab.title}</IonLabel>
            </IonTabButton>
          );
        })}
      </IonTabBar>
    </IonTabs>
  );
};
